//PrintLegend2D.tsx =================================================
import * as Default from "../Default";
import * as MainMap from "../MainMap";
import * as PrintMap from "../Print/PrintMap";

import React from "react";

const legendDiv: string = "printLegendDiv2D";

interface iProps {
}

//Render function.
export function Render(props: iProps) {
   //Util.logMsg("Top of AdvancedSearch Render");

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
      import("@arcgis/core/widgets/Legend").then(({ default: LegendWidget }) => {
         const widget = new LegendWidget({
            container: legendDiv,
            view: MainMap.activeView,
         });

      }).catch((error: Error) => {
         console.error('An error occurred while loading the Legend Widget module:', error);
      });
   }, []);

   const styles: Default.iStyles = {
      legend: { overflow: 'hidden', maxHeight: PrintMap.imageHeight },
   };

   return (
      <div id={legendDiv} style={styles.legend}></div>
   ); //end return.

} //end function.
